import * as Types from '../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type SchoolsImportSchoolClassesMutationVariables = Types.Exact<{
  file: Types.Scalars['schoolsUpload'];
}>;


export type SchoolsImportSchoolClassesMutation = { __typename?: 'Mutation', schoolsImportSchoolClasses?: boolean | null | undefined };


export const SchoolsImportSchoolClassesDocument = gql`
    mutation SchoolsImportSchoolClasses($file: schoolsUpload!) {
  schoolsImportSchoolClasses(file: $file)
}
    `;
export type SchoolsImportSchoolClassesMutationFn = Apollo.MutationFunction<SchoolsImportSchoolClassesMutation, SchoolsImportSchoolClassesMutationVariables>;

/**
 * __useSchoolsImportSchoolClassesMutation__
 *
 * To run a mutation, you first call `useSchoolsImportSchoolClassesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSchoolsImportSchoolClassesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [schoolsImportSchoolClassesMutation, { data, loading, error }] = useSchoolsImportSchoolClassesMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useSchoolsImportSchoolClassesMutation(baseOptions?: Apollo.MutationHookOptions<SchoolsImportSchoolClassesMutation, SchoolsImportSchoolClassesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SchoolsImportSchoolClassesMutation, SchoolsImportSchoolClassesMutationVariables>(SchoolsImportSchoolClassesDocument, options);
      }
export type SchoolsImportSchoolClassesMutationHookResult = ReturnType<typeof useSchoolsImportSchoolClassesMutation>;
export type SchoolsImportSchoolClassesMutationResult = Apollo.MutationResult<SchoolsImportSchoolClassesMutation>;
export type SchoolsImportSchoolClassesMutationOptions = Apollo.BaseMutationOptions<SchoolsImportSchoolClassesMutation, SchoolsImportSchoolClassesMutationVariables>;